import * as HttpService from './HttpService'

let namespace = 'tips'

let list = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let singleRandom = (params, cb, errorCb) => {
    HttpService.get(namespace + '/single-random', params, cb, errorCb)
}

export {
    list,
    singleRandom
}



// WEBPACK FOOTER //
// ./src/services/tipService.js